<template>
  <div v-if="isLoggedIn" class="bg-grey py-5">
    <div class="kws-int-container">
      <h3 class="h3" v-if="translations.lblUpcomingHeadline" v-text="translate('lblUpcomingHeadline')"></h3>
      <div v-if="translations.lblUpcomingSubHeadline" v-html="translate('lblUpcomingSubHeadline')"></div>
      <p class="error-box" v-if="isError" v-text="error"></p>
      <div v-else-if="isMyUpcomingEventsEmpty">
        <h2 v-text="translate('lblNoUpcomingEventsFound')"></h2>
      </div>
      <EventTable
        :events="myUpcomingEvents"
        :format-end-date="formatEndDate"
        :format-start-date="formatStartDate"
        :api-url="apiUrl"
        :user-id="myUserID"
        :is-participants-module-active-for-this-project="isParticipantsModuleActiveForThisProject"
        @unsubscribeEvent="handleUnsubscribeEvent"
      ></EventTable>
    </div>
    <LoadingIndicator v-if="isLoading"></LoadingIndicator>
  </div>
</template>

<script>
import EventMixin from './mixins/EventMixin';
import EventTable from './components/event-table.vue';
import LoadingIndicator from '../shared/components/loading-indicator.vue';
import EventPermissionsMixin from './mixins/EventPermissionsMixin';

export default {
  name: 'MyEvents',
  components: {
    EventTable,
    LoadingIndicator,
  },
  data: () => ({
    myUpcomingEvents: [],
    error: null,
    loading: false,
    myUserID: '',
  }),
  mixins: [EventMixin, EventPermissionsMixin],
  props: {
    translations: Object,
    detailView: {
      type: String,
      required: true,
    },
    participantsView: {
      type: String,
      required: false,
    },
    apiUrl: {
      type: String,
      required: true,
    },
    formatStartDate: {
      type: String,
      required: true,
    },
    formatEndDate: {
      type: String,
      required: true,
    },
  },
  provide() {
    return {
      detailView: this.detailView,
      participantsView: this.participantsView,
    };
  },
  computed: {
    isError() {
      return !!this.error;
    },
    isLoading() {
      return this.loading && !this.isError;
    },
    isMyUpcomingEventsEmpty() {
      return !this.myUpcomingEvents.length && !this.isError && !this.isLoading;
    },
    isLoggedIn() {
      return !!window.KWS && !!window.KWS.user;
    },
  },
  methods: {
    isEventDataInvalid(eventData) {
      return !eventData?.data?.info?.Campaigns?.length && !eventData?.data?.info?.myUser_ID__c;
    },
    getEvents(eventData) {
      return eventData?.data?.info?.Campaigns || [];
    },
    getMyUserId(eventData) {
      return eventData?.data?.info?.myUser_ID__c ?? '';
    },
    ascendingStartDates(eventA, eventB) {
      return new Date(eventA.startDate) - new Date(eventB.startDate);
    },
    async handleUnsubscribeEvent() {
      this.processEventData(await this.getEventData(`${this.apiUrl}/campaign/events/participating/`));
    },
    isUpcoming(event) {
      if (!event?.startDate) { return false; }

      const now = new Date();
      now.setUTCHours(0, 0, 0, 0);
      const eventStartDate = new Date(event.startDate);
      return now.getTime() <= eventStartDate.getTime();
    },
    assignCurrentUserRegistrationStatus(event) {
      if (!event || !event.CampaignMembers) return event;
      const currentUserRegistration = {
        currentUserRegistrationStatus: event.CampaignMembers.find((member) => member && member.myUser_ID__c && member.myUser_ID__c === this.myUserID).EventRegistrationStatus__c,
      };
      return Object.assign(event, currentUserRegistration);
    },
    processEventData(eventData) {
      if (this.isEventDataInvalid(eventData)) { return; }

      this.myUserID = this.getMyUserId(eventData);

      this.myUpcomingEvents = this.getEvents(eventData)
        .map(this.renameObjectKeys)
        .map(this.getEventWithAdditionalContentFor)
        .filter(this.isUpcoming)
        .sort(this.ascendingStartDates)
        .map(this.assignCurrentUserRegistrationStatus)
        .filter(this.isEventUnsubscribable);
    },
  },
  mounted() {
    this.$root.$on('showLoadingState', (val) => {
      this.loading = val;
    });
  },
  async created() {
    if (!this.isLoggedIn) return;
    if (this.translations) {
      this.addDictionary(this.translations);
    }
    this.processEventData(await this.getEventData(`${this.apiUrl}/campaign/events/participating/`));
  },
};
</script>
